/**
 * Read-only Vergleichs-Spalte für den Side-by-Side-Modus (C2-B).
 *
 * Zeigt den effektiven Feldwert des Vergleichsziels (Master oder anderer Channel)
 * mit Quell-Badge (MASTER/ABWEICHUNG/Vom Master). Rein referenziell, nicht editierbar.
 */

import { useTranslation } from 'react-i18next'

interface Props {
  targetName: string
  value: string
  badge: 'master' | 'override' | 'inherited'
}

export function ContentComparePanel({ targetName, value, badge }: Props) {
  const { t } = useTranslation()
  const badgeLabel =
    badge === 'master'
      ? t('productContent.channels.masterLabel')
      : badge === 'override'
        ? t('productContent.channels.overriddenLabel')
        : t('productContent.channels.inheritedFromMaster')
  const badgeClass =
    badge === 'override'
      ? 'bg-primary-100 text-primary-700 dark:bg-primary-900/40 dark:text-primary-300'
      : 'bg-neutral-100 text-neutral-600 dark:bg-neutral-800 dark:text-neutral-300'

  return (
    <div className="content-compare-panel rounded-lg border border-dashed border-neutral-300 dark:border-neutral-700 p-3 bg-neutral-50 dark:bg-neutral-900/40">
      <div className="flex items-center gap-2 mb-1.5">
        <span className="text-xs font-medium text-neutral-600 dark:text-neutral-300 truncate">{targetName}</span>
        <span className={`text-xs px-1.5 py-0.5 rounded ${badgeClass}`}>{badgeLabel}</span>
      </div>
      <pre className="whitespace-pre-wrap text-sm text-neutral-700 dark:text-neutral-300 font-sans min-h-[3rem]">
        {value || t('content.noContent')}
      </pre>
    </div>
  )
}
